import { Box, Button, Select, Stack, Title } from "@mantine/core"
import { isNotEmpty, useForm } from "@mantine/form"
import { IconArrowLeft, IconArrowRight } from "@tabler/icons"
import { Content } from "components/common"
import { IHomeFormVerifyIdentityValues, homeHooks } from "features/homes"
import { useNavigate, useParams, useSearchParams } from "react-router-dom"
import { useUserRoutes } from "routes"
import { ErrorUtils } from "utils/error"

export function HomeFormVerifyIdentityPage() {
  const { homeId } = useParams()
  const [searchParams] = useSearchParams()
  const taskId = searchParams.get("taskId")

  const navigate = useNavigate()
  const { routesResolver } = useUserRoutes()

  const { mutateAsync } = homeHooks.useSubmitIdentityVerification()

  const form = useForm<IHomeFormVerifyIdentityValues>({
    validate: {
      isUserReal: isNotEmpty("This field is required"),
    },
    validateInputOnChange: true,
    initialValues: {
      id: parseInt(homeId || ""),
      taskId: parseInt(taskId || ""),
      isUserReal: "",
    },
  })

  async function onSubmit() {
    if (!homeId) return
    if (!form.validate().hasErrors) {
      try {
        await mutateAsync(form.values)
        navigate(routesResolver.getHomeDetailsById(parseInt(homeId || "")))
      } catch (error) {
        ErrorUtils.handleError(
          "Error submitting form",
          "We apologize, something went wrong submitting your form",
          error
        )
      }
    }
  }

  return (
    <Content.Body>
      <Stack>
        <Box>
          <Button
            leftIcon={<IconArrowLeft />}
            onClick={() =>
              navigate(
                routesResolver.getHomeDetailsById(parseInt(homeId || ""))
              )
            }
          >
            Back
          </Button>
        </Box>
        <Title>Identity Verification</Title>
        <form>
          <Stack spacing={"lg"}>
            <Select
              label="Are you who you say you are? -- Need to integrate Plaid here"
              required
              data={[
                { value: "yes", label: "Yes" },
                { value: "no", label: "No" },
              ]}
              {...form.getInputProps("isUserReal")}
            />
          </Stack>
          <Button rightIcon={<IconArrowRight />} mt={"lg"} onClick={onSubmit}>
            Submit
          </Button>
        </form>
      </Stack>
    </Content.Body>
  )
}
